import React, { useMemo } from 'react';
import VerifiedIcon from '../../../icons/VerifiedIcon';
import useCustomerStore from '../../../../stores/customerStore';
import useSaasPlatformStore from '../../../../stores/saasPlatformStore';
import useWidgetStore, { CurrentTabEnum } from '../../../../stores/widgetStore';
import useProductStore from '../../../../stores/productStore';
import useConfigStore from '../../../../stores/configStore';
import useLatestQuotesWithPolicies from '../../../../hooks/useLatestQuotesWithPolicies';
var PolicyAuditStartRequest = function () {
    var _a = useCustomerStore(), applicationFormData = _a.applicationFormData, policyAuditFlowType = _a.policyAuditFlowType;
    var Products = useSaasPlatformStore().Products;
    var _b = useWidgetStore(), setFormActive = _b.setFormActive, setModalOpen = _b.setModalOpen, setAnswers = _b.setAnswers, setApplicationDataId = _b.setApplicationDataId, setCurrentTab = _b.setCurrentTab, setSelectedQuote = _b.setSelectedQuote;
    var setProduct = useProductStore().setProduct;
    var style = useConfigStore().style;
    var theme = style.theme;
    var latestQuotesWithPolicies = useLatestQuotesWithPolicies();
    var isFlow2 = policyAuditFlowType === '2';
    // Keys
    var applicationKeys = Object.keys(applicationFormData || {});
    var primaryKey = applicationKeys[0];
    var secondaryKey = applicationKeys.find(function (key) { return key !== primaryKey; });
    // Find currentItem for primary key
    var currentItem = latestQuotesWithPolicies.find(function (_a) {
        var externalId = _a.externalId;
        return externalId === primaryKey;
    });
    // Single button config - works for both flows
    var buttonConfig = useMemo(function () {
        var _a;
        if (!currentItem) {
            return {
                text: isFlow2 ? 'Start Policy Review' : 'Start Request',
                variant: 'primary'
            };
        }
        var currQuestionGroup = (_a = currentItem === null || currentItem === void 0 ? void 0 : currentItem.items.otherParams) === null || _a === void 0 ? void 0 : _a.currQuestionGroup;
        if (currQuestionGroup === 1) {
            return {
                text: 'Submit Additional Policies for Review',
                variant: 'outline'
            };
        }
        return { text: 'Continue Request', variant: 'outline' };
    }, [currentItem, isFlow2]);
    var handleSelection = function (key) {
        var _a;
        if (applicationFormData && applicationFormData[key]) {
            var applicationData_1 = applicationFormData[key];
            var product = (_a = Products === null || Products === void 0 ? void 0 : Products.find) === null || _a === void 0 ? void 0 : _a.call(Products, function (p) { return p.id == applicationData_1.productId; });
            var item = latestQuotesWithPolicies.find(function (_a) {
                var externalId = _a.externalId;
                return externalId === key;
            });
            setApplicationDataId(key);
            setAnswers((item === null || item === void 0 ? void 0 : item.items.requiredParams) || applicationData_1.applicationDetails);
            if (product) {
                setProduct(product);
            }
            setFormActive(true);
            setCurrentTab(CurrentTabEnum.POLICY);
            setSelectedQuote(null);
        }
        setModalOpen(true);
    };
    // Title
    var title = isFlow2
        ? 'Free Policy Review & Insurance Quote'
        : 'Free Policy Review';
    // Button styles
    var primaryButtonClass = "w-full h-14 rounded-2xl bg-primary text-white text-base font-semibold shadow-lg ".concat(theme === 'night' ? 'rippleNight' : 'ripple');
    var lightButtonClass = 'w-full h-14 rounded-2xl bg-blue-100 text-primary text-base font-semibold';
    var isPrimary = buttonConfig.variant === 'primary';
    return (React.createElement("div", null,
        React.createElement("div", { className: "rounded-3xl mx-2 mt-30 px-12 bg-backgroundColor my-2 flex flex-col h-full justify-center text-textColor" },
            React.createElement("div", { className: "flex flex-col items-center justify-center" },
                React.createElement(VerifiedIcon, null),
                React.createElement("span", { className: "text-2xl font-bold text-center w-full mt-5 text-[#1F2751]" }, title),
                !isFlow2 && (React.createElement("span", { className: "text-base font-normal text-center mt-1 text-[#6B7280]" }, "Identify coverage you don't need and what you're missing"))),
            React.createElement("button", { className: "mt-6 ".concat(isPrimary ? primaryButtonClass : lightButtonClass), onClick: function () { return handleSelection(primaryKey); } }, buttonConfig.text),
            isFlow2 && secondaryKey && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "text-center text-gray-500 my-2" }, "or"),
                React.createElement("button", { className: primaryButtonClass, onClick: function () { return handleSelection(secondaryKey); } }, "Start Application"))))));
};
export default PolicyAuditStartRequest;
